var _path, _path2, _circle, _g, _ellipse, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicLinkLockError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 93,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.8 30.764V18.203A18.186 18.186 0 0034.575 1.386 18.19 18.19 0 009.42 18.203v12.561A9.457 9.457 0 00.39 40.208v29.684h54.443V40.209a9.458 9.458 0 00-9.032-9.444zM27.61 6.418a11.798 11.798 0 0111.785 11.785v12.54H15.826v-12.54A11.798 11.798 0 0127.611 6.418z",
    fill: "#3C3C3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.505 45.386a4.893 4.893 0 10-7.647 4.045v10.637h5.505V49.43a4.888 4.888 0 002.142-4.044z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.611,
    cy: 20,
    r: 16,
    fill: "#E95832"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#magic-link-lock-error_svg__clip0_27294_107897)",
    stroke: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.586 15.712a7.01 7.01 0 004.42 4.438 7.018 7.018 0 00-4.42 4.418 7.018 7.018 0 00-4.42-4.42 7.048 7.048 0 004.42-4.436zM48.39 26.017a5.732 5.732 0 00-3.229 3.23 5.731 5.731 0 00-3.229-3.23 5.722 5.722 0 003.23-3.242 5.723 5.723 0 003.229 3.242zm-3.229-4.459a.205.205 0 00-.21.169l.46.178a5.214 5.214 0 01-.02-.089v-.002a6.22 6.22 0 01-.02-.087.205.205 0 00-.21-.169zM42.445 20.19a5.745 5.745 0 00-3.276-3.28 5.675 5.675 0 003.276-3.291 5.649 5.649 0 003.281 3.29 5.718 5.718 0 00-3.28 3.28z"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 85.892,
    rx: 18,
    ry: 7,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "magic-link-lock-error_svg__clip0_27294_107897"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(37.61 11)",
    d: "M0 0h21.032v21.032H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/magic-link-lock-error.9d88b03f.svg";
export { SvgMagicLinkLockError as ReactComponent };